var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 24.08C25.24 24.08 24.56 24.38 24.04 24.85L16.91 20.7C16.96 20.47 17 20.24 17 20C17 19.76 16.96 19.53 16.91 19.3L23.96 15.19C24.5 15.69 25.21 16 26 16C27.66 16 29 14.66 29 13C29 11.34 27.66 10 26 10C24.34 10 23 11.34 23 13C23 13.24 23.04 13.47 23.09 13.7L16.04 17.81C15.5 17.31 14.79 17 14 17C12.34 17 11 18.34 11 20C11 21.66 12.34 23 14 23C14.79 23 15.5 22.69 16.04 22.19L23.16 26.35C23.11 26.56 23.08 26.78 23.08 27C23.08 28.61 24.39 29.92 26 29.92C27.61 29.92 28.92 28.61 28.92 27C28.92 25.39 27.61 24.08 26 24.08Z",
    fill: "#00E6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#00E6FF",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSm);
export default __webpack_public_path__ + "static/media/share-sm.e043005755a8f5fb7199e0999f73b3c2.svg";
export { ForwardRef as ReactComponent };